import { createFileRoute } from '@tanstack/react-router'
import { requireHub } from '../../../features/settings/guards'
import { SettingsIndex } from '../../../features/settings/hub'

/** `/settings`: the first section the user may manage (a list of sections on phones and tablets). */
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: ({ context }) => requireHub(context.session),
  component: SettingsIndex,
})
